import { create } from 'zustand';

const useToastStore = create((set, get) => ({
  visible: false,
  message: '',
  onUndo: null,
  // 'success' (verde, o de sempre) ou 'error' (vermelho). O aviso de erro
  // precisava existir: uma edição recusada pelo servidor ficava colada na
  // tela até o poll apagá-la em silêncio, e o usuário não tinha como saber
  // que o valor não foi salvo.
  variant: 'success',
  _timeoutId: null,

  show: ({ message, onUndo = null, duration = 5000, variant = 'success' }) => {
    const { _timeoutId } = get();
    if (_timeoutId) clearTimeout(_timeoutId);

    const timeoutId = setTimeout(() => {
      get().hide();
    }, duration);

    set({ visible: true, message, onUndo, variant, _timeoutId: timeoutId });
  },

  /** Atalho para erro: fica mais tempo na tela, porque exige leitura. */
  showError: (message, duration = 8000) => get().show({ message, variant: 'error', duration }),

  hide: () => {
    const { _timeoutId } = get();
    if (_timeoutId) clearTimeout(_timeoutId);
    set({ visible: false, message: '', onUndo: null, variant: 'success', _timeoutId: null });
  },
}));

export default useToastStore;
